import { Action, createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import * as Actions from './shift-swap.actions';
import { initialState, ShiftSwapState } from './shift-swap.state';

export const shiftSwapReducer = createReducer(
  initialState,
  on(Actions.getShiftSwapApprovalDataSucceeded, (state, { payload }) => {
    const updatedState = cloneDeep(state);
    updatedState.data = payload.shiftRequests;
    updatedState.ui.isShiftRequestsLoaded = true;
    return updatedState;
  }),
  on(
    Actions.menuInitialized,
    Actions.menuSaved,
    Actions.shiftSwapApprovalPageRefreshed,
    Actions.shiftRequestApprovalSucceeded,
    Actions.shiftRequestDenialSucceeded,
    (state, { entId, fromDate, toDate }) => {
      const updatedState = cloneDeep(state);
      updatedState.ui.isShiftRequestsLoaded = false;
      updatedState.ui.menu = { entId, fromDate, toDate };
      return updatedState;
    },
  ),
  on(
    Actions.approveSwapClicked,
    Actions.approveOfferClicked,
    Actions.denySwapClicked,
    Actions.denyOfferClicked,
    (state) => {
      const updatedState = cloneDeep(state);
      updatedState.ui.isShiftRequestsLoaded = false;
      return updatedState;
    },
  ),
);

export function reducer(state: ShiftSwapState | undefined, action: Action) {
  return shiftSwapReducer(state, action);
}
